module.exports = __webpack_public_path__ + "static/img/bg67.02d5f435.png";